<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="参数值" prop="paramsValue">
				<el-input clearable v-model="editForm.paramsValue" class="input_200px" size="small" auto-complete="off" placeholder="请输入参数值"></el-input>
			</el-form-item>
			<el-form-item label="排序号" prop="seq">
				<el-input v-model.number="editForm.seq" class="input_200px" size="small" auto-complete="off" placeholder="请输入排序号" :min="1" :step="1"></el-input>
				<!-- <el-tooltip
          class="item"
          effect="dark"
          content="排序号按照从小到大的顺序排序，不管是列表，还是其他功能中的下拉选择框！"
          placement="top"
        >
        </el-tooltip> -->
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { SaveGoodsParams, GetGoodsParamsDetail } from "@/api/baseDataApi.js";
export default {
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				type: 0,
				paramsValue: "",
				seq: 1
			},
			// rules 表单验证
			rules: {
				paramsValue: [
					{
						required: true,
						message: "请输入参数信息",
						trigger: "blur"
					}
				],
				seq: [
					{
						required: true,
						message: "请输入排序号",
						trigger: "blur"
					},
					{
						type: "number",
						message: "请输入数字",
						trigger: ["blur", "change"]
					}
				]
			}
		};
	},
	computed: {},
	watch: {},

	methods: {
		//显示编辑界面
		editShow(row, type) {
			this.$data.editForm = this.$options.data.call(this).editForm;
			this.editForm.type = type;
			if (row) {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				GetGoodsParamsDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.editForm.keyId = res.data.keyId;
							this.editForm.paramsValue = res.data.paramsValue;
							this.editForm.type = res.data.type;
							this.editForm.seq = res.data.seq;
							this.editFormVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("供应商信息获取失败!");
					});
			} else {
				this.title = "新增";
				this.editFormVisible = true;
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveGoodsParams(this.editForm)
						.then((res) => {
							this.editFormVisible = false;
							this.loading = false;
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "商品参数保存成功！"
								});
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("商品参数保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
</style>
